/* Feinkost Angelo - Bewegungen, Handy-Menue und Variantenauswahl.
   Bewusst ohne fremde Bibliotheken. Faellt das Skript aus, bleibt die Seite lesbar und
   der Warenkorb funktioniert weiter (das Formular traegt immer eine gueltige Variante).
   Die Korb-Bewegungen im Kopfbereich laufen rein ueber CSS - das laeuft fluessiger,
   weil der Browser sie auf der Grafikkarte rechnet und kein Skript je Bild arbeitet. */
(function () {
  'use strict';

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Einblenden beim Scrollen ---------- */
  function einblenden(bereich) {
    var ziele = bereich.querySelectorAll('.fa .reveal:not([data-fa-gesehen])');
    if (!ziele.length) return;
    if (ruhig || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(ziele, function (el) { el.setAttribute('data-fa-gesehen', '1'); });
      return;
    }
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.remove('js-hidden');
          beobachter.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    /* Was beim Laden schon im Fenster steht, bleibt sichtbar. Vorher wurde auch das
       kurz versteckt und wieder eingeblendet - auf der Produktseite stand das Foto
       dadurch erst leer da, und die Seite wirkte, als wuerde sie haengen (2026-10-05). */
    var hoehe = window.innerHeight || document.documentElement.clientHeight;
    Array.prototype.forEach.call(ziele, function (el) {
      el.setAttribute('data-fa-gesehen', '1');
      var r = el.getBoundingClientRect();
      if (r.top < hoehe && r.bottom > 0) return;
      el.classList.add('js-hidden');
      beobachter.observe(el);
    });
  }

  /* ---------- Kopfbereich ruht, wenn er nicht zu sehen ist ----------
     Die Koerbe schweben, das Licht wandert, das Siegel dreht sich - das braucht
     niemand, waehrend weiter unten gelesen wird. Ausserhalb des Blicks wird es
     angehalten, beim Zurueckscrollen laeuft es an derselben Stelle weiter. */
  function kopfRuhe(bereich) {
    if (!('IntersectionObserver' in window)) return;
    var koepfe = bereich.querySelectorAll('.fa .hero:not([data-fa-ruhe])');
    Array.prototype.forEach.call(koepfe, function (kopf) {
      kopf.setAttribute('data-fa-ruhe', '1');
      new IntersectionObserver(function (eintraege) {
        kopf.classList.toggle('fa-ruht', !eintraege[0].isIntersecting);
      }).observe(kopf);
    });
  }

  /* ---------- "So laeuft es ab": 01 -> 02 -> 03 nacheinander hervorheben ----------
     Der Wechsel laeuft nur, solange der Abschnitt zu sehen ist. */
  function ablauf(bereich) {
    var gitter = bereich.querySelectorAll('.fa .ablauf-grid:not([data-fa-ablauf])');
    if (!gitter.length) return;
    Array.prototype.forEach.call(gitter, function (grid) {
      grid.setAttribute('data-fa-ablauf', '1');
      var schritte = grid.querySelectorAll('.ablauf-schritt');
      if (schritte.length < 2 || ruhig || !('IntersectionObserver' in window)) return;

      var i = 0, uhr = null;
      function weiter() {
        Array.prototype.forEach.call(schritte, function (s) {
          s.classList.remove('active');
          s.classList.add('fa-ablauf-laeuft');
        });
        schritte[i].classList.add('active');
        i = (i + 1) % schritte.length;
      }
      function anhalten() {
        if (uhr) { clearInterval(uhr); uhr = null; }
      }

      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting && !uhr) {
            weiter();
            uhr = setInterval(weiter, 2600);
          } else if (!e.isIntersecting) {
            anhalten();
          }
        });
      }, { threshold: 0.4 });
      beobachter.observe(grid);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) anhalten();
      });
    });
  }

  /* ---------- Handy-Menue ---------- */
  function menue(bereich) {
    var knoepfe = bereich.querySelectorAll('.fa .nav-burger:not([data-fa-menue])');
    Array.prototype.forEach.call(knoepfe, function (knopf) {
      knopf.setAttribute('data-fa-menue', '1');
      var ziel = document.getElementById(knopf.getAttribute('aria-controls'));
      if (!ziel) return;

      function zu() {
        ziel.classList.remove('open');
        ziel.setAttribute('aria-hidden', 'true');
        knopf.setAttribute('aria-expanded', 'false');
      }
      knopf.addEventListener('click', function () {
        var offen = ziel.classList.toggle('open');
        ziel.setAttribute('aria-hidden', offen ? 'false' : 'true');
        knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
      });
      Array.prototype.forEach.call(ziel.querySelectorAll('a'), function (a) {
        a.addEventListener('click', zu);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') zu();
      });
    });
  }

  /* ---------- Variantenauswahl auf der Produktseite ----------
     Regel wie bei Shopify selbst: Beim Pruefen einer Option zaehlen nur die Optionen
     DAVOR. Sonst wuerde "Senza Alcol" durchgestrichen, nur weil davor "Rotwein" steht. */
  function produkt(bereich) {
    var wurzeln = bereich.querySelectorAll('[data-fa-produkt]:not([data-fa-bereit])');

    Array.prototype.forEach.call(wurzeln, function (wurzel) {
      wurzel.setAttribute('data-fa-bereit', '1');

      var datenFeld = wurzel.querySelector('[data-fa-varianten]');
      if (!datenFeld) return;
      var varianten = [];
      try { varianten = JSON.parse(datenFeld.textContent); } catch (e) { return; }
      if (!varianten.length) return;

      var idFeld = wurzel.querySelector('[data-fa-variant-id]');
      var preisFeld = wurzel.querySelector('[data-fa-preis]');
      var kaufKnopf = wurzel.querySelector('[data-fa-kaufen]');
      var knoepfe = Array.prototype.slice.call(wurzel.querySelectorAll('.groesse[data-option]'));
      if (!knoepfe.length) return;

      var anzahlOptionen = 0;
      knoepfe.forEach(function (b) {
        var i = parseInt(b.getAttribute('data-option'), 10);
        if (i > anzahlOptionen) anzahlOptionen = i;
      });

      function knoepfeVon(i) {
        return knoepfe.filter(function (b) { return parseInt(b.getAttribute('data-option'), 10) === i + 1; });
      }

      function gewaehlteWerte() {
        var werte = [];
        for (var i = 0; i < anzahlOptionen; i++) {
          var aktiv = knoepfeVon(i).filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
          werte[i] = aktiv ? aktiv.getAttribute('data-wert') : null;
        }
        return werte;
      }

      /* Erste Variante, die zu den ersten n Werten passt (spaetere Optionen egal) */
      function trefferMitAnfang(werte, n) {
        for (var i = 0; i < varianten.length; i++) {
          var v = varianten[i], passt = true;
          for (var k = 0; k < n; k++) {
            if (werte[k] != null && v.options[k] !== werte[k]) { passt = false; break; }
          }
          if (passt) return v;
        }
        return null;
      }

      function genaueVariante(werte) {
        for (var i = 0; i < varianten.length; i++) {
          var v = varianten[i], passt = true;
          for (var k = 0; k < anzahlOptionen; k++) {
            if (v.options[k] !== werte[k]) { passt = false; break; }
          }
          if (passt) return v;
        }
        return null;
      }

      function setzeWert(i, wert) {
        knoepfeVon(i).forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-wert') === wert ? 'true' : 'false');
        });
      }

      function aktualisieren() {
        var werte = gewaehlteWerte();

        /* Passen spaetere Optionen nicht mehr zur neuen Auswahl, werden sie nachgezogen */
        for (var i = 0; i < anzahlOptionen; i++) {
          if (!trefferMitAnfang(werte, i + 1)) {
            var ersatz = trefferMitAnfang(werte, i);
            if (ersatz) {
              werte[i] = ersatz.options[i];
              setzeWert(i, werte[i]);
            }
          }
        }

        /* Ausgrauen: nur die Optionen davor zaehlen */
        for (var j = 0; j < anzahlOptionen; j++) {
          knoepfeVon(j).forEach(function (b) {
            var probe = werte.slice(0, j);
            probe[j] = b.getAttribute('data-wert');
            var kandidat = trefferMitAnfang(probe, j + 1);
            b.classList.toggle('nicht-verfuegbar', !kandidat);
            var preisImKnopf = b.querySelector('[data-fa-knopfpreis]');
            if (preisImKnopf) preisImKnopf.textContent = kandidat ? kandidat.preis_text : '';
          });
        }

        var v = genaueVariante(werte) || trefferMitAnfang(werte, anzahlOptionen);
        if (!v) return;
        if (idFeld) idFeld.value = v.id;
        if (preisFeld) preisFeld.textContent = v.preis_text;
        if (kaufKnopf) {
          kaufKnopf.disabled = !v.available;
          kaufKnopf.textContent = v.available
            ? kaufKnopf.getAttribute('data-text-kaufen')
            : kaufKnopf.getAttribute('data-text-ausverkauft');
        }
      }

      knoepfe.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = parseInt(b.getAttribute('data-option'), 10) - 1;
          setzeWert(i, b.getAttribute('data-wert'));
          aktualisieren();
        });
      });

      aktualisieren();
    });
  }

  function start(bereich) {
    var ziel = bereich || document;
    einblenden(ziel);
    kopfRuhe(ziel);
    ablauf(ziel);
    menue(ziel);
    produkt(ziel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
